import {Box, Flex, Image, Text} from '@chakra-ui/react'
import {Fragment, useState} from 'react'
import {Popover} from 'antd'
import Word from './Word'
import Overview from './Overview'
import PopoverContent from './PopoverContent'
import {useDispatch, useSelector} from 'react-redux'
import {
  updateIsOpenBadPause,
  updateIsPauseAudio,
} from '@redux/exam-result/examResult'
import {getIconByChar} from './utilsExamResult'

const TabContent1 = ({audioRef}: any) => {
  const {dataExamResult, audioTime, isPauseAudio} = useSelector(
    (state: any) => state.examResult,
  )
  const [currentSelectWord, setCurrentSelectWord] = useState<any>(null)
  const [isOpenPopover, setIsOpenPopover] = useState<any>(false)
  const [currentBadPause, setCurrentBadPause] = useState<any>()
  const [isOpenPopoverBadPause, setIsOpenPopoverBadPause] = useState<any>(false)
  const dispatch = useDispatch()

  const handleClickWord = (word: any) => {
    audioRef.current.currentTime =
      Number(word.start_time?.toFixed(6)) + 0.000002
    dispatch(updateIsPauseAudio(true))
    dispatch(updateIsOpenBadPause(false))
    setCurrentSelectWord(word)
  }

  const handleClickBadPause = (word: any, words: any, wordIndex: any) => {
    if (wordIndex === 0) {
      audioRef.current.currentTime =
        Number(word.start_time.toFixed(6)) + 0.000002
    } else {
      if (word.start_time === words[wordIndex - 1].end_time) {
        audioRef.current.currentTime =
          Number(word.start_time.toFixed(6)) + 0.000002
      } else {
        audioRef.current.currentTime =
          Number(word.start_time.toFixed(6)) - 0.000002
      }
    }
    dispatch(updateIsPauseAudio(true))
    dispatch(updateIsOpenBadPause(true))
  }

  const handleOpenPopover = (value: boolean) => {
    setIsOpenPopover(value)
  }

  const handleOpenPopoverBadPause = (value: boolean) => {
    setIsOpenPopoverBadPause(value)
    setIsOpenPopover(false)
    if (!value) {
      setCurrentBadPause(null)
    }
  }

  return (
    <Box pb={'120px'}>
      <Overview />
      {/* Danh sách câu hỏi và trà lời */}
      <Flex
        maxW={'860px'}
        mx={'auto'}
        mt={{base: '40px', md: '80px'}}
        flexDirection={'column'}
        gap={'40px'}>
        {dataExamResult?.transcript_review?.transcripts.map(
          (question: any, questionIndex: any) => {
            return (
              <Box key={questionIndex} className={`${question.part_type}`}>
                <Text
                  fontSize={{base: '16px', md: '20px'}}
                  fontWeight={600}
                  color={'#434343'}
                  p={{base: '16px', md: '20px'}}
                  borderRadius={'12px'}
                  bg={
                    'linear-gradient(90deg, #F0F0F0 0%, rgba(240, 240, 240, 0.00) 100%)'
                  }>
                  {question.question}
                </Text>
                <Flex mt={{base: '16px', md: '20px'}} flexWrap={'wrap'}>
                  {question.words.map((word: any, wordIndex: any) => (
                    <Fragment key={wordIndex}>
                      {currentBadPause?.start_time === word.start_time ? (
                        <Popover
                          content={
                            <Box
                              color={'#EC652C'}
                              fontSize={'24px'}
                              fontWeight={600}
                              p={'8px 20px'}>
                              Bad Pause
                            </Box>
                          }
                          placement="bottom"
                          arrow={false}
                          title={null}
                          trigger="click"
                          open={isOpenPopoverBadPause}
                          overlayInnerStyle={{
                            padding: '0px',
                          }}
                          onOpenChange={(val: any) => {
                            handleOpenPopoverBadPause(val)
                          }}>
                          {word.is_bad_pause && (
                            <Text
                              position={'relative'}
                              borderRadius={'15px'}
                              cursor={'pointer'}
                              as={'span'}
                              fontSize={{base: '20px', md: '28px'}}
                              fontWeight={600}
                              px={'4px'}
                              color={'white'}
                              bg={'#EC652C'}
                              onClick={() => {
                                handleClickBadPause(
                                  word,
                                  question.words,
                                  wordIndex,
                                )
                                setCurrentBadPause(word)
                              }}>
                              ~
                              {!isPauseAudio && (
                                <Image
                                  className="status-phrase"
                                  opacity={
                                    audioTime.currentWordTime >=
                                      word.start_time.toFixed(6) - 0.000002 &&
                                    audioTime.currentWordTime <= word.end_time
                                      ? 1
                                      : 0
                                  }
                                  src={getIconByChar('~')}
                                  position={'absolute'}
                                  zIndex={1}
                                  top={
                                    audioTime.currentWordTime >=
                                      word.start_time.toFixed(6) - 0.000002 &&
                                    audioTime.currentWordTime <= word.end_time
                                      ? '-40px'
                                      : '10px'
                                  }
                                  left={0}
                                  transition={'top 1s, opacity 0.2s'}
                                  userSelect={'none'}
                                />
                              )}
                            </Text>
                          )}
                        </Popover>
                      ) : (
                        <>
                          {word.is_bad_pause && (
                            <Text
                              position={'relative'}
                              borderRadius={'8px'}
                              cursor={'pointer'}
                              as={'span'}
                              fontSize={{base: '20px', md: '28px'}}
                              fontWeight={600}
                              px={'4px'}
                              color={'#EC652C'}
                              onClick={() => {
                                handleClickBadPause(
                                  word,
                                  question.words,
                                  wordIndex,
                                )
                                setCurrentBadPause(word)
                                handleOpenPopoverBadPause(true)
                              }}>
                              ~
                              {!isPauseAudio && (
                                <Image
                                  className="status-phrase"
                                  opacity={
                                    audioTime.currentWordTime >=
                                      word?.start_time?.toFixed(6) - 0.000002 &&
                                    audioTime.currentWordTime <= word.end_time
                                      ? 1
                                      : 0
                                  }
                                  src={getIconByChar('~')}
                                  position={'absolute'}
                                  zIndex={1}
                                  top={
                                    audioTime.currentWordTime >=
                                      word?.start_time?.toFixed(6) - 0.000002 &&
                                    audioTime.currentWordTime <= word.end_time
                                      ? '-40px'
                                      : '10px'
                                  }
                                  left={0}
                                  transition={'top 1s, opacity 0.2s'}
                                  userSelect={'none'}
                                />
                              )}
                            </Text>
                          )}
                        </>
                      )}
                      {currentSelectWord &&
                      currentSelectWord.start_time === word.start_time &&
                      currentSelectWord?.word === word?.word ? (
                        <Popover
                          content={<PopoverContent word={word} />}
                          placement="bottom"
                          arrow={false}
                          title={null}
                          trigger="click"
                          open={isOpenPopover}
                          overlayInnerStyle={{
                            padding: '0px',
                          }}
                          onOpenChange={val => {
                            handleOpenPopover(val)
                            if (val) {
                              handleClickWord(word)
                            }
                          }}>
                          <Word
                            word={word}
                            currentSelectWord={currentSelectWord}
                            setIsOpenPopover={setIsOpenPopover}
                            handleClickWord={handleClickWord}
                          />
                        </Popover>
                      ) : (
                        <Word
                          word={word}
                          currentSelectWord={currentSelectWord}
                          setIsOpenPopover={setIsOpenPopover}
                          handleClickWord={handleClickWord}
                        />
                      )}
                    </Fragment>
                  ))}
                </Flex>
              </Box>
            )
          },
        )}
      </Flex>
    </Box>
  )
}

export default TabContent1
